/** OIDC-Redirect-Ziel: /tester/callback (Umsetzungsplan §5).
 * Zwei Auth-Versionen: Logto (Kundeninstanzen) und Authentik/OIDC (neue
 * Projekte der Produktionslinie) — der Modus kommt aus VITE_AUTH_MODE. */

import { useEffect, useState } from "react"
import { useHandleSignInCallback } from "@logto/react"
import { useNavigate } from "react-router-dom"
import { getUserManager } from "@/components/auth/AuthentikBridge"
import { AUTH_MODE } from "@/store/auth"

function LogtoCallback() {
  const navigate = useNavigate()
  const { isLoading } = useHandleSignInCallback(() => {
    navigate("/", { replace: true })
  })

  return (
    <div className="flex h-screen items-center justify-center text-muted-foreground">
      {isLoading ? "Anmeldung wird abgeschlossen …" : null}
    </div>
  )
}

function AuthentikCallback() {
  const navigate = useNavigate()
  const [fehler, setFehler] = useState<string | null>(null)

  useEffect(() => {
    getUserManager()
      .signinCallback()
      .then(() => navigate("/", { replace: true }))
      .catch((e: unknown) => setFehler(e instanceof Error ? e.message : String(e)))
  }, [navigate])

  return (
    <div className="flex h-screen items-center justify-center text-muted-foreground">
      {fehler ? `Anmeldung fehlgeschlagen: ${fehler}` : "Anmeldung wird abgeschlossen …"}
    </div>
  )
}

export function CallbackPage() {
  if (AUTH_MODE === "authentik") return <AuthentikCallback />
  return <LogtoCallback />
}
